import React, { useEffect } from "react";
import brandStore from "../../store/brandStore";
import MyLoader from "../myLoader/MyLoader";

const RequireBrand = (props) => {
  const BrandStore = brandStore();
  useEffect(() => {
    if (BrandStore.brand === null) {
      BrandStore.fetchBrand();
    }
  }, []);

  return (
    <>
      {BrandStore.brand === null ? (
        <MyLoader height="100vh" />
      ) : (
        <div>{props.children}</div>
      )}
    </>
  );
};

export default RequireBrand;
